// Modo de demonstração — deixa o proprietário navegar pelas telas
// (influenciador e admin) com dados fictícios, ANTES de existir backend
// real (migration ainda não aplicada, nenhum afiliado cadastrado de
// verdade). Só existe pra isso: nunca aparece numa build de produção.
//
// `import.meta.env.DEV` é substituído em tempo de build pelo Vite — numa
// build de produção (`npm run build`) ele vira `false` literal e o
// bundler elimina este código por completo (dead code elimination).
// Mesmo que alguém force a chave no localStorage do site publicado, a
// checagem de DEV abaixo garante que isso nunca ativa o modo de
// demonstração fora de `npm run dev`.

const DEMO_MODE_STORAGE_KEY = 'ca-render-demo-mode';

export function isDemoModeEnabled(): boolean {
  return import.meta.env.DEV && window.localStorage.getItem(DEMO_MODE_STORAGE_KEY) === '1';
}

export function enableDemoMode(): void {
  window.localStorage.setItem(DEMO_MODE_STORAGE_KEY, '1');
}

export function disableDemoMode(): void {
  window.localStorage.removeItem(DEMO_MODE_STORAGE_KEY);
}
